import { UiKitRatingBase } from '@/fo/ui/kit/rating/base';

import { styles } from './UiKitRatingBlock.styles';

export interface UiKitRatingBlockProps {
  value: number;
  maxValue?: number;
  className?: string;
}

/**
 * Блок рейтинга, отображающий значение рейтинга и звезды
 */
export function UiKitRatingBlock({
  value,
  maxValue = 5,
  className
}: UiKitRatingBlockProps) {
  const slots = styles();

  return (
    <div className={slots.container({ className })}>
      <span className={slots.value()}>{value.toFixed(1)}</span>
      <UiKitRatingBase
        value={value}
        maxValue={maxValue}
        starClassName={slots.star()}
        className={slots.starsContainer()}
      />
    </div>
  );
}
